import React from "react";
import SearchComponent from "./Search";

const Search = () => {
  return <SearchComponent />;
};

export default Search;
